module.exports = __webpack_public_path__ + "assets/img/91b7-cc.svg";